import { Row, Container } from 'react-bootstrap';
import { useParams, useSearchParams } from 'react-router-dom';
import { useEffect, useRef } from 'react';

import Message from '../../components/layout/Message';
import Paginate from '../../components/ui/Paginate';
import ProductCard from '../../components/product/ProductCard';
import ProductsCarousel from '../../components/product/ProductsCarousel';
import { useGetProductsQuery } from '../../slices/productApiSlice';
import { useSelector } from 'react-redux';
import SortSelect from '../../components/ui/SortSelect';
import Meta from '../../components/layout/Meta';
import SeasonalBanner from '../../components/ui/SeasonalBanner';
import ProductCardSkeleton from '../../components/ui/ProductCardSkeleton';
import ActiveGlobalDiscountBanner from '../../components/ui/ActiveGlobalDiscountBanner';
import ShippingBehaviorBanner from '../../components/ui/ShippingBehaviorBanner';

const HomeScreen = () => {
    const { userInfo } = useSelector((state) => state.auth);
    const { pageNumber, keyword } = useParams();

    const [searchParams] = useSearchParams();
    const sort = searchParams.get('sort') || '';

    const {
        data: productsData,
        isLoading,
        isFetching,
        error,
    } = useGetProductsQuery({
        keyword,
        pageNumber,
        priceAssigned: userInfo?.priceAssigned || null,
        sort,
    });

    const productosSectionRef = useRef(null);

    useEffect(() => {
        if (
            productosSectionRef.current &&
            productsData &&
            productsData.page > 1 &&
            !isLoading &&
            !isFetching &&
            !error &&
            productsData.products &&
            productsData.products.length > 0
        ) {
            setTimeout(() => {
                productosSectionRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 50);
        }
    }, [productsData, productsData?.page, isLoading, isFetching, error]);

    return (
        <Container className="pt-2 pt-md-3 pb-4">
            {!keyword ? <Meta /> : <Meta title={`Resultados para ${keyword}`} />}
            <div className="home-promo-banners">
                <ActiveGlobalDiscountBanner allowGuestPrompt prominent />
                <div id="home-shipping-banner" className="home-promo-slot">
                    <ShippingBehaviorBanner prominent />
                </div>
            </div>

            {!keyword && !isLoading && !isFetching && (
                <SeasonalBanner userInfo={userInfo} />
            )}

            {/* Destacados/Featured Section */}
            {!keyword &&
                (!isLoading || !isFetching) &&
                productsData &&
                productsData.products.length > 0 && (
                    <section className="featured-section mb-5">
                        <div className="featured-header">
                            <h2 className="section-title mb-1">¡Recomendados para ti!</h2>
                            <p className="featured-subtitle mb-3">Novedades y Tendencias</p>
                        </div>
                        <ProductsCarousel />
                    </section>
                )}

            {isLoading || isFetching ? (
                <Row className="mx-0">
                  <div className="ProductGrid">
                    {[...Array(8)].map((_, idx) => (
                      <ProductCardSkeleton key={idx} />
                    ))}
                  </div>
                </Row>
            ) : error ? (
                <Message variant="danger">{error?.data?.message || error.error}</Message>
            ) : (
                <>
                    <div
                        id="productos-section"
                        ref={productosSectionRef}
                        className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3"
                        style={{ scrollMarginTop: '6rem' }}
                    >
                        {!keyword && (
                            <h2 className="section-title mb-0">Nuestros Productos</h2>
                        )}
                        <div style={{ minWidth: '200px' }}>
                            <SortSelect currentSort={sort} />
                        </div>
                    </div>

                    <Row className="mx-0">
                        <div className="ProductGrid">
                            {productsData.products.map((product) => (
                                <ProductCard product={product} key={product._id} />
                            ))}
                        </div>
                    </Row>
                    <div className="mt-4">
                        <Paginate
                            pages={productsData.pages}
                            page={productsData.page || 1}
                            keyword={keyword ? keyword : ''}
                            sort={sort}
                        />
                    </div>
                </>
            )}
        </Container>
    );
};
export default HomeScreen;
